import { action } from 'typesafe-actions'
import { Quiz } from '@models/quiz'
import {RequestData} from "@models/axios";



export const enum QuizzesActionTypes {
    FETCH_REQUEST = '@@quizzes/FETCH_REQUEST',
    FETCH_SUCCESS = '@@quizzes/FETCH_SUCCESS',
    FETCH_ERROR = '@@quizzes/FETCH_ERROR',

    DELETE_REQUEST = '@@quizzes/DELETE_REQUEST',
    DELETE_SUCCESS = '@@quizzes/DELETE_SUCCESS',
    DELETE_ERROR = '@@quizzes/DELETE_ERROR',

    CREATE_REQUEST = '@@quizzes/CREATE_REQUEST',
    CREATE_SUCCESS = '@@quizzes/CREATE_SUCCESS',
    CREATE_ERROR = '@@quizzes/CREATE_ERROR',

    UPDATE_REQUEST = '@@quizzes/UPDATE_REQUEST',
    UPDATE_SUCCESS = '@@quizzes/UPDATE_SUCCESS',
    UPDATE_ERROR = '@@quizzes/UPDATE_ERROR',

    FETCH_ITEM_REQUEST = '@@quizzes/FETCH_ITEM_REQUEST',
    FETCH_ITEM_SUCCESS = '@@quizzes/FETCH_ITEM_SUCCESS',
    FETCH_ITEM_ERROR = '@@quizzes/FETCH_ITEM_ERROR',

    FETCH_QUESTIONS_SUCCESS = '@@quizzes/FETCH_QUESTIONS_SUCCESS',
}



export const fetchRequest = (data:RequestData) => action(QuizzesActionTypes.FETCH_REQUEST, data);
export const fetchSuccess = (data: Quiz[]) => action(QuizzesActionTypes.FETCH_SUCCESS, data);
export const fetchError = (message: string) => action(QuizzesActionTypes.FETCH_ERROR, message);

export const deleteRequest = (data:RequestData) => action(QuizzesActionTypes.DELETE_REQUEST, data);
export const deleteSuccess = (data:any) => action(QuizzesActionTypes.DELETE_SUCCESS, data);
export const deleteError = (message: string) => action(QuizzesActionTypes.DELETE_ERROR, message);

export const createRequest = (data:RequestData) => action(QuizzesActionTypes.CREATE_REQUEST, data);
export const createSuccess = (data: Quiz[]) => action(QuizzesActionTypes.CREATE_SUCCESS, data);
export const createError = (message: string) => action(QuizzesActionTypes.CREATE_ERROR, message);

export const updateRequest = (data:RequestData) => action(QuizzesActionTypes.UPDATE_REQUEST, data);
export const updateSuccess = (data: Quiz[]) => action(QuizzesActionTypes.UPDATE_SUCCESS, data);
export const updateError = (message: string) => action(QuizzesActionTypes.UPDATE_ERROR, message);

export const fetchItemRequest = (data:RequestData) => action(QuizzesActionTypes.FETCH_ITEM_REQUEST, data);
export const fetchItemSuccess = (data: Quiz[]) => action(QuizzesActionTypes.FETCH_ITEM_SUCCESS, data);
export const fetchItemError = (message: string) => action(QuizzesActionTypes.FETCH_ITEM_ERROR, message);